export type BrandId = 'handy';

export function isHandyHost(): boolean {
  if (typeof window === 'undefined') return true;
  return true; // Always Handy
}

export function getBrand(): BrandId {
  return 'handy';
}

export function getBrandName(): string {
  return 'Handy';
}

export function getDefaultLanguage(): 'en' | 'ko' | 'id' {
  return 'ko';
}

export function getDefaultDarkMode(): boolean {
  return false;
}

export function getWalletTitle(): string {
  return 'Handy Wallet — Handy Blockchain';
}


